export default __webpack_public_path__ + "static/media/india-responsible-capital-conference-IRCC-2023.2e83d7f7.jpg";